<template>
  <div class="card border-psychology-warning/30">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-3 mb-6 text-psychology-warning">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
          <path d="M12 9v4"></path>
          <path d="M12 17h.01"></path>
        </svg>
        重要注意事项
      </div>

      <div class="bg-psychology-warning/5 border border-psychology-warning/20 rounded-lg p-4">
        <div class="space-y-3 text-sm">
          <div class="flex items-start gap-2">
            <div class="w-1.5 h-1.5 bg-psychology-warning rounded-full mt-2 flex-shrink-0"></div>
            <span><strong>非诊断工具：</strong>RPI指数仅供自我了解和关系反思，不能替代专业心理咨询或情感咨询</span>
          </div>
          <div class="flex items-start gap-2">
            <div class="w-1.5 h-1.5 bg-psychology-warning rounded-full mt-2 flex-shrink-0"></div>
            <span><strong>隐私保护：</strong>所有数据仅在您的设备本地存储，不会上传到任何服务器</span>
          </div>
          <div class="flex items-start gap-2">
            <div class="w-1.5 h-1.5 bg-psychology-warning rounded-full mt-2 flex-shrink-0"></div>
            <span><strong>适用人群：</strong>本测评适用于18岁以上恋爱中或有恋爱经历的成年人</span>
          </div>
          <div class="flex items-start gap-2">
            <div class="w-1.5 h-1.5 bg-psychology-warning rounded-full mt-2 flex-shrink-0"></div>
            <span><strong>理性看待：</strong>占有欲是复杂的情感现象，需要辩证看待，过高或过低都可能影响关系质量</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportantNotes'
}
</script>

